/**
 * Complete list of "Full Sale" transaction types from IntelliJetNet.
 * IMPORTANT: This list must include ALL "Full Sale" transaction types to ensure
 * all sold aircraft are detected and snapshots are created.
 * Previously this list was incomplete (missing "to Dealer", "to Management Company",
 * "to Financial Institution", "to Leasing Company" types), causing aircraft sold to
 * dealers/institutions to never appear in the Sold container.
 */
export const FULL_SALE_TRANSACTION_TYPES = [
  'Full Sale - Retail to Unidentified',
  'Full Sale - Retail to Retail',
  'Full Sale - Dealer to Retail',
  'Full Sale - Dealer to Unidentified',
  'Full Sale - Charter Company to Unidentified',
  'Full Sale - Aviation Related Business to Unidentified',
  'Full Sale - Management Company to Unidentified',
  'Full Sale - Retail to Aviation Related Business',
  'Full Sale - Retail to Aircraft Parts',
  'Full Sale - Dealer to Charter Company',
  'Full Sale - Retail to Charter Company',
  'Full Sale - Financial Institution to Unidentified',
  'Full Sale - Retail to Program Holder',
  'Full Sale - Unidentified to Charter Company',
  'Full Sale - Charter Company to Retail',
  'Full Sale - Management Company to Retail',
  'Full Sale - Unidentified to Retail',
  'Full Sale - Ferrying Company to Unidentified',
  'Full Sale - Charter Company to Aircraft Parts',
  'Full Sale - Air Ambulance to Retail',
  'Full Sale - Leasing Company to Retail',
  'Full Sale - Ferrying Company to Retail',
  'Full Sale - Unidentified to Program Holder',
  'Full Sale - Airlines to Unidentified',
  'Full Sale - Retail to Air Ambulance',
  'Full Sale - Charter Company to Charter Company',
  'Full Sale - Aviation Related Business to Retail',
  'Full Sale - Program Holder to Unidentified',
  'Full Sale - Retail to Air Taxi',
  'Full Sale - Program Holder to Retail',
  'Full Sale - Flight School to Retail',
  'Full Sale - Leasing Company to Charter',
  // Dealer as buyer
  'Full Sale - Dealer to Dealer',
  'Full Sale - Charter Company to Dealer',
  'Full Sale - Retail to Dealer',
  'Full Sale - Unidentified to Dealer',
  'Full Sale - Aviation Related Business to Dealer',
  'Full Sale - Management Company to Dealer',
  'Full Sale - Financial Institution to Dealer',
  'Full Sale - Leasing Company to Dealer',
  // Aviation Related Business as buyer (additional)
  'Full Sale - Dealer to Aviation Related Business',
  'Full Sale - Charter Company to Aviation Related Business',
  'Full Sale - Unidentified to Aviation Related Business',
  'Full Sale - Aviation Related Business to Aviation Related Business',
  'Full Sale - Management Company to Aviation Related Business',
  'Full Sale - Financial Institution to Aviation Related Business',
  'Full Sale - Leasing Company to Aviation Related Business',
  // Management Company as buyer
  'Full Sale - Retail to Management Company',
  'Full Sale - Dealer to Management Company',
  'Full Sale - Charter Company to Management Company',
  'Full Sale - Unidentified to Management Company',
  'Full Sale - Aviation Related Business to Management Company',
  'Full Sale - Management Company to Management Company',
  'Full Sale - Financial Institution to Management Company',
  'Full Sale - Leasing Company to Management Company',
  // Financial Institution as buyer/seller (additional)
  'Full Sale - Financial Institution to Retail',
  'Full Sale - Retail to Financial Institution',
  'Full Sale - Dealer to Financial Institution',
  'Full Sale - Charter Company to Financial Institution',
  'Full Sale - Unidentified to Financial Institution',
  'Full Sale - Aviation Related Business to Financial Institution',
  'Full Sale - Management Company to Financial Institution',
  'Full Sale - Financial Institution to Financial Institution',
  'Full Sale - Financial Institution to Charter Company',
  'Full Sale - Leasing Company to Financial Institution',
  // Leasing Company as buyer (additional)
  'Full Sale - Retail to Leasing Company',
  'Full Sale - Dealer to Leasing Company',
  'Full Sale - Charter Company to Leasing Company',
  'Full Sale - Unidentified to Leasing Company',
  'Full Sale - Aviation Related Business to Leasing Company',
  'Full Sale - Management Company to Leasing Company',
  'Full Sale - Financial Institution to Leasing Company',
  // Leasing Company as seller (additional)
  'Full Sale - Leasing Company to Charter Company',
  'Full Sale - Leasing Company to Unidentified',
  'Full Sale - Leasing Company to Management Company',
  'Full Sale - Leasing Company to Leasing Company'
] as const

